module.exports = __webpack_public_path__ + "static/media/AvenirLTStd-Roman.8b3d3eca.eot";